module.exports = __webpack_public_path__ + "img/88.ba72354a.jpg";